const routePaths = {
  HOME: "/",
  SETTINGS: "/settings",
  RESETPASSWORD: "/reset-password",
  DASHBOARD: "/dashboard",
  MOBILE: "/mobile",
  CHANGE_PASSWORD: "/change-password",
  MANAGE_USERS: "/manage-users",
  REPORTS: "/reports",
  SALES: "/sales",
  CONVERSION: "/conversion",
  VIEW_USER: "/manage-users/view-user/:id",
  BAN_USER: "/ban-user",
  USER_MODIFICATION: "/user-modification",
  /** @deprecated Redirects to dashboard; kept for old bookmarks */
  OTHERS: "/others",
  MANAGE_BADGE: "/manage-badge",
  MANAGE_CATEGORY: "/manage-category",
  MANAGE_CHALLENGE: "/manage-challenge",
  MANAGE_THEME: "/manage-theme",
  MANAGE_POLLS: "/manage-polls",
  MANAGE_CONTESTS: "/manage-contests",
  CALENDAR: "/calendar",
  CALENDAR_PRINT: "/calendar/print",
  MANAGE_AUDIO: "/manage-audio",
  MANAGE_KARAOKE: "/manage-karaoke",
  MANAGE_DANCE: "/manage-dance",
  MANAGE_RAP: "/manage-rap",
  MANAGE_ADMIN_SETTINGS: "/manage-admin-settings",
  MANAGE_ADMIN_ACCOUNTS: "/manage-admin-accounts",
  MANAGE_GAMEPLAY_SETTINGS: "/manage-gameplay-settings",
  MANAGE_FACE_VERIFICATION: "/manage-face-verification",
  MANAGE_SEASON: "/manage-season",
  MANAGE_APPEALS: "/manage-appeals",
  ANTI_CHEAT: "/anti-cheat",
  MANAGE_NOTIFICATIONS: "/manage-notifications",
  MANAGE_MESSAGES: "/manage-messages",
  MANAGE_PATCH_UPDATES: "/manage-patch-updates",
  MANAGE_PAGENT_POSTS: "/manage-pagent-posts",
  REVIEW_CONTACT_FORM: "/review-contact-form",
  CHAT: "/chat",
  MANAGE_FAQ: "/faq's",
  PROFILE_SETTINGS: "/profile-settings",
  /** @deprecated Redirects to MANAGE_NOTIFICATIONS; kept for old bookmarks */
  BROADCAST_NOTIFICATIONS: "/broadcast-notifications",
  MANAGE_TICKET: "/manage-ticket",
  MANAGE_APP_DATA: "/manage-app-data",
  TERMS_CONDITIONS: "/terms-conditions",
  PRIVACY_POLICY: "/privacy-policy",
  MANAGE_FEEDBACK: "/manage-feedback",
  POST_DETAIL: "/manage-ticket/post/:postId", // Updated route with dynamic segment
  COMMENT_DETAIL: "/manage-ticket/comment/:commentId",
  USER_REPORT_DETAIL: "/manage-ticket/user/:userId",
  // Cheating tickets are keyed by the accused opponent entry (a post id).
  CHEATING_DETAIL: "/manage-ticket/cheating/:postId",
  NOT_FOUND: "*",
  uploadKaraoke: "/manage-karaoke/upload",
  uploadDance: "/manage-dance/upload",
  CURATED_MATCHES: "/curated-matches",
  FILM_FEED: "/film-feed",
  IN_PROGRESS_MATCHES: "/in-progress-matches",
};

export default routePaths;
